import { Space } from 'antd';
import React, { FC } from 'react';
import styled from 'styled-components';
import { ClassNameOnlyProps } from 'components/ozone-component';

interface AppearanceProps extends ClassNameOnlyProps {
  title: React.ReactNode;
  icon: React.ReactNode;
}

export const Appearance: FC<AppearanceProps> = ({ className, title, icon }) => {
  return (
    <Space direction="vertical" className={className}>
      <div>{title}</div>
      <div>{icon}</div>
    </Space>
  );
};

export const AppearanceMini = styled(Appearance)`
  svg {
    width: 144px;
    height: 96px;
  }
`;
